// extracted by mini-css-extract-plugin
export default {"box":"box-ydZR1","header":"header-dim0m","level":"level-SXehp"};